import { SET_EXPORTS_REFETCH } from 'actions';

export default function setExportsRefetch() {
  return {
    type: SET_EXPORTS_REFETCH,
  };
}
